import React from 'react';

const BabyVaccination = () => {
    return (
        <div className='baby-vaccine-bann'>
            <img src='images/8.png'alt='Baby Vaccine' ></img>
        </div>
    );
};

export default BabyVaccination;